var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-label"},[_c('div',{staticClass:"collapse-label__label",on:{"click":function($event){return _vm.toggleClick()}}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.canOpen)?_c('div',{staticClass:"collapse-label__toggle",on:{"click":function($event){return _vm.toggleOpen()}}},[_c('ToggleArrow',{attrs:{"width":8,"closed":!_vm.open}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369930e6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navigation/CountriesNavigation/CollapseLabel.vue
// module id = 280
// module chunks = 0